import { useAuth } from '@clerk/clerk-react'
import { trpc } from './trpc'
import { inferRouterOutputs } from '@trpc/server'
import { AppRouter } from '@tagadapay/trpc-types'

type OutputRouter = inferRouterOutputs<AppRouter>

// Output types
export type AccountInfo = OutputRouter['account']['getAccountInfo']
export type AccountManagerInfo = OutputRouter['account']['getAccountManagerInfo']

// Hook for getting account info
export const useGetAccountInfo = () => {
	const { isSignedIn } = useAuth()

	return trpc.account.getAccountInfo.useQuery(undefined, {
		enabled: !!isSignedIn,
	})
}

export const useAccountManagerInfo = () => {
	const { isSignedIn } = useAuth()

	return trpc.account.getAccountManagerInfo.useQuery(undefined, {
		enabled: !!isSignedIn,
		staleTime: 5 * 60_000,
	})
}

export const useUpdateAccount = () => {
	const utils = trpc.useUtils()

	return trpc.account.updateAccount.useMutation({
		onSuccess: () => {
			utils.account.getAccountInfo.invalidate()
		},
	})
}

